module.exports = __webpack_public_path__ + "img/type-01.cb6d8b84.svg";